// Globals
import { ComponentType } from 'react';
import { useTranslation } from 'react-i18next';

// Components
import { Pagination, Table } from '@/ui';
import { StyledWrapper } from '../Styled';
import { StyledPagination } from './OrdersTableStyles';

// Models
import { IOrder } from '@/models/order.model';
import { IPagination } from '@/models/pagination.model';

// Helpers
import { getEntityId } from '@/utils';
import { getOrdersTableColumns } from '../../helpers';

type TOrderListProps = {
  data: IOrder[];
  isLoading: boolean;
  header?: ComponentType;
  onPageChange?: (pagination: { cursor?: string; limit?: number }) => void;
  pagination?: IPagination;
  onRowClick?: (id: string) => void;
};

const OrdersTable = ({ isLoading, data, header, onPageChange, pagination, onRowClick }: TOrderListProps) => {
  const { t } = useTranslation('order');

  return (
    <StyledWrapper>
      <Table
        columns={getOrdersTableColumns({ t })}
        onRow={({ PK }) => ({
          onClick: () => onRowClick?.(getEntityId(PK)),
        })}
        rowKey="PK"
        dataSource={data}
        scroll={{ x: 'max-content' }}
        loading={isLoading}
        components={{
          header: {
            wrapper: header,
          },
        }}
      />
      <StyledPagination>
        <Pagination onChange={onPageChange} cursor={pagination} />
      </StyledPagination>
    </StyledWrapper>
  );
};

export default OrdersTable;
